import { Component, Input, OnInit } from '@angular/core';
import { GTMService } from 'src/app/services/gtm.service';
import { VouchersService } from 'src/app/services/vouchers.service';
import { Router } from '@angular/router';

@Component({
  selector: 'invitation-vouchers',
  providers: [GTMService, VouchersService],
  styleUrls: ['./invitation-vouchers.component.scss'],
  template: `
    <div class="vouchers-card">
      <overlay-loading *ngIf="loading"></overlay-loading>

      <div class="vouchers-container">
        <div class="card-title">Vouchers</div>

        <div class="voucher" [class.last]="!vouchers?.length && !canGenerateVouchers">
          <img [src]="voucherProvider?.logo_url" alt="Voucher iFood">
          <div class="voucher-info">
            <div class="voucher-description">
              R$ {{voucherProvider?.amount}} para usar no {{voucherProvider?.name}}
            </div>
            <span>Bloqueado</span>
          </div>
          <div class="voucher-progress">
            <span [ngStyle]="{width: getPercentage(unassignedInvites)}"></span>
          </div>
          <div class="progress-status">
            Você precisa que {{ 3 - unassignedInvites }} {{ (3 - unassignedInvites) > 1 ? 'amigos se cadastrem' : 'amigo se cadastre' }}
          </div>
        </div>

        <div class="voucher last" *ngIf="canGenerateVouchers">
          <img [src]="voucherProvider?.logo_url" alt="Voucher iFood">
          <div class="voucher-info">
            <div class="voucher-description">
              R$ {{voucherProvider?.amount}} para usar no {{voucherProvider?.name}}
            </div>
            <span (click)="redirectToVouchers('ver-voucher')" class="active">Ver voucher</span>
          </div>
          <div class="voucher-progress">
            <span class="active"></span>
          </div>
          <div class="progress-status">
            Voucher liberado!
          </div>
        </div>
      </div>
      <button *ngIf="vouchers?.length && !canGenerateVouchers" (click)="redirectToVouchers('ver-todos')" class="btn">Ver todos</button>
    </div>
  `
})

export class InvitationVouchersComponent implements OnInit {
  @Input()
  loading: boolean;

  @Input()
  invites: any[] = [];

  @Input()
  vouchers: any[] = [];

  @Input()
  voucherProvider: any;

  canGenerateVouchers = false;

  constructor(
    private gtm: GTMService,
    private vouchersService: VouchersService,
    private router: Router
  ) { }

  ngOnInit() {
    this.vouchersService.canGenerate().subscribe(({ canGenerateVoucher }) => {
      this.canGenerateVouchers = canGenerateVoucher;
    });
  }

  get unassignedInvites() { return this.invites ? (this.invites.length % 3) : 0; }

  getPercentage = (qtd: number) => `${(100 / 3) * qtd}%`;

  redirectToVouchers(label: string) {
    this.gtm.interaction('allya:mgm', 'mgm:meus-vouchers:click', label);

    this.router.navigate(['/vouchers']);
  }
}
